import React, { PropTypes } from 'react';
import { Button, ButtonGroup, Table } from 'react-bootstrap';

import CityRow from './CityRow';
import LocalBrowserRow from './LocalBrowserRow';
import CustomCdnImage from './CustomCdnImage';
import CloudinaryColumnHeaderIcon from './CloudinaryColumnHeaderIcon';

import ColumnHeaderIcon from './ColumnHeaderIcon';

const FETCH_CDN_PROVIDER_IMAGE_PREFIX = 'https://res.cloudinary.com/demo/image/fetch/h_50,dpr_auto,c_fill,f_auto/';

const CdnProvidersTable = ({image, transformation}) =>
    (
        <div className="cdn-providers-table-container">
            <Table responsive hover striped className="cdn-providers-table">
                <thead>
                    <tr>
                        <th className="cdn-provider-city-name" />
                        <th>
                            <ColumnHeaderIcon cdnCode="ak" />
                            <CustomCdnImage image={image} transformation={transformation} cdnCode="ak" />
                        </th>
                        <th>
                            <ColumnHeaderIcon cdnCode="fy" />
                            <CustomCdnImage image={image} transformation={transformation} cdnCode="fy" />
                        </th>
                        <th>
                            <ColumnHeaderIcon cdnCode="cf" />
                            <CustomCdnImage image={image} transformation={transformation} cdnCode="cf" />
                        </th>
                        <th className="cdn-cloudinary">
                            <CloudinaryColumnHeaderIcon />
                            <CustomCdnImage image={image} transformation={transformation} cdnCode="mc" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <LocalBrowserRow image={image} transformation={transformation} />
                    <CityRow image={image} transformation={transformation} country="United States" city="San Jose" countryCode="us" countryLabel="US" />
                    <CityRow image={image} transformation={transformation} country="United States" city="Dulles" countryCode="us" countryLabel="US" />
                    <CityRow image={image} transformation={transformation} country="United Kingdom" city="London" countryCode="gb" countryLabel="UK" />
                    <CityRow image={image} transformation={transformation} country="Argentina" city="Buenos Aires" countryCode="ar" />
                    <CityRow image={image} transformation={transformation} country="Australia" city="Sydney" countryCode="au" />
                    <CityRow image={image} transformation={transformation} country="Hong Kong" city="Hong Kong" countryCode="hk" countryLabel="" />
                </tbody>
            </Table>
            <div className="cdn-disclaimer">* Note: Performance statistics of the worldwide locations were pre-generated</div>
        </div>
    );

CityRow.PropTypes = {
    image: PropTypes.string.isRequired,
    transformation: PropTypes.object.isRequired
};

export default CdnProvidersTable;



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/CdnProvidersTable.js
 **/